@if (errorChat) {
  <div class="am-flex-column am-flex-center p-xl gap-xxs bg-border-grey b-radius-wide height-full c1000-height-max-300-i">
    <span class="am-flex-center font-icon icon-chat"></span>
    <span>Demnächst verfügbar</span>
  </div>
} @else if (loading || room) {
  <div class="am-flex-justify gap-m pl-s pr-s pt-s pb-xxxs">
    <span class="am-flex-align gap-xs">
      @if (loading) { <span class="loading-animate width-xxl height-xxl"></span> }
      @else         { <span class="bg-light-blue p-xxs b-radius color-blue am-flex-center font-icon-small icon-chat"></span> }
      <span class="font-500" [ngClass]="loading ? 'loading-animate color-transparent' : ''">Chatverlauf</span>
    </span>
    @if      (loading)               { <span class="height-xl loading-animate width-40"></span> }
    @else if (room?.owner?.isOnline) { <span class="height-xl bg-light-blue b-radius color-blue am-flex-align font-s pl-xs pr-xs hover-active">Live</span> }
  </div>
  <div #chatBox class="am-flex-column am-flex-1 gap-xxs overflow-auto font-s pl-m pr-m pt-s pb-s mt-s bt-grey">
    @if (loading) {
      <span class="loading-animate height-80 width-three-quarters mra"></span>
      <span class="loading-animate height-80 width-three-quarters mla"></span>
    } @else {
      @for (message of room?.messages | sortBy: ['seq'] : false; track $index) {
        @if (showDate(message, room.messages, $index)) { <span class="am-flex-center p-xs font-s font-500">{{ getDateTitle(message) }}</span> }

        @if (!message.deletedAt && message.bulkMessageId) {
          <span class="am-flex-align gap-xxs font-s font-500">
            <span>Gruppen-Nachricht</span>
            @if (getName(message.participantId)) { <span>({{ getName(message.participantId) }})</span> }
          </span>
        }

        <div class="am-flex-column gap-xxs lh-m b-radius-wide p-xs relative" #content
            [class.width-250]=" !message.deletedAt && !message.bulkMessageId"
            [class.width-full]="!message.deletedAt &&  message.bulkMessageId"
            [ngClass]="getBubbleStyle(message, room.messages[$index+1])">
          @if (message.deletedAt) { <span class="font-s color-disabled">Nachricht gelöscht</span> }
          @else {
            <span class="am-flex-justify gap-m am-flex-align-start">
              <div class="am-flex-column gap-xs">
                @if (!message.bulkMessageId && showParticipantName($index, message, room.messages[$index-1])) { <span class="font-s font-500">{{ getName(message.participantId) }}</span> }
                <span class="am-flex-1 word-break-all">{{ message.text }}</span>
              </div>
            </span>
            <span class="am-flex-align-end gap-xxs font-s mla mta">
              @if (message.editedAt) { <span class="font-xs">(<span>Bearbeitet</span>)</span> }
              <span>{{ message.createdAt | date: 'HH:mm' }}</span>
              @if (isOwnMessage(message)) { <span class="am-flex-center font-l" [ngClass]="messageIsRead(message) ? 'icon-ticks' : 'icon-tick'"></span> }
            </span>
          }
        </div>
      }
    }
  </div>

  <div class="am-flex-center p-s bt-grey" [class.hover-active]="!loading">
    @if (loading) { <span class="loading-animate width-100 height-xxl"></span> }
    @else {
      <span class="am-flex-align gap-xxs color-blue height-xxl font-s" (click)="openRoom()">
        <span class="am-flex-center font-icon-small icon-chat-send"></span>
        <span>Chat öffnen</span>
      </span>
    }
  </div>
}
